import instance from '@instance';
import devConsole from '@utils/developer-console';

export const formatLeagueSlug = (slug: string) => {
  if (!slug) return '';
  if (slug === 'ncaa--2') return 'NCAA-MENS-FOOTBALL';

  if (slug === 'ncaa-men--2') return 'NCAA-MENS-BASKETBALL';

  if (slug.startsWith('mls')) return 'MLS';
  return slug.toUpperCase();
};

export const getVenueImages = async (events, leagueOverride?: string) => {
  if (!events) return [];
  const uniqueVenueIds = new Map<string, { venueId: number; league: string }>();

  events.forEach((event) => {
    const venueId = event?.venue?.id;
    // A canonical league (e.g. the page's requested categoryName) takes
    // precedence over the event's own category slug, since TicketEvolution
    // sometimes tags live events under a legacy/aliased slug (e.g. La Liga
    // events come back as "spanish-primera-division", not "la-liga") that
    // won't match our league-keyed venue image data or default fallbacks.
    const league = leagueOverride ?? formatLeagueSlug(event?.category?.slug);
    if (!venueId || !league) return;

    uniqueVenueIds.set(`${venueId}:${league}`, { venueId, league });
  });

  const venueIds = Array.from(uniqueVenueIds.values());

  try {
    const body = JSON.stringify(venueIds);
    const imagesList = await instance.server('/image/venues', { body });
    const response = await imagesList.json();

    if (response?.error) return [];
    return response;
  } catch (e) {
    devConsole({ error: e });
    return [];
  }
};
